import React from 'react'
import { Form } from 'semantic-ui-react'
import Metadata from '../Metadata'

const details = ({obj, language, onChange}) => {
  return (
    <div>
      <Form.Field>
        <Form.Input label='Titre' placeholder="Titre de la page" id="title" value={obj.translations[language.code].title} onChange={(e) => onChange(e, language.code)} />
      </Form.Field>
      <Metadata obj={obj} language={language} onChange={onChange} />
    </div>
  )
}

export default details



// WEBPACK FOOTER //
// ./src/components/form/pageBuilder/details.js